var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 86,
    viewBox: "0 0 95 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_127_176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.9231 82.7795C91.9231 82.7795 88.1955 73.1191 80.3344 65.4324C71.7887 57.0795 58.6025 55.4473 48.324 61.6349C36.1775 68.9468 28.8743 82.2048 6.39014 81.1805C6.39014 81.1805 24.3606 88.3009 48.7889 72.1197C50.7415 70.8289 52.8293 69.738 55.027 68.9052C76.928 60.6022 91.9231 82.7795 91.9231 82.7795Z",
    fill: "#DF76F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4418 85.2528C62.5359 85.2528 65.8549 81.9829 65.8549 77.9493C65.8549 73.9156 62.5359 70.6457 58.4418 70.6457C54.3477 70.6457 51.0288 73.9156 51.0288 77.9493C51.0288 81.9829 54.3477 85.2528 58.4418 85.2528Z",
    fill: "#DF76F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3501 0.757874C51.3501 0.757874 44.9768 8.96919 42.4832 19.5956C39.7699 31.1547 45.3065 43.0553 56.0583 48.4102C68.7627 54.7311 84.0452 53.8733 94.9999 73.244C94.9999 73.244 91.678 54.4396 64.8576 42.4974C62.7106 41.5397 60.6735 40.3654 58.797 38.9663C40.0996 25.0004 51.3501 0.757874 51.3501 0.757874Z",
    fill: "#DF76F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7983 38.6499C68.8924 38.6499 72.2113 35.38 72.2113 31.3463C72.2113 27.3126 68.8924 24.0427 64.7983 24.0427C60.7042 24.0427 57.3853 27.3126 57.3853 31.3463C57.3853 35.38 60.7042 38.6499 64.7983 38.6499Z",
    fill: "#DF76F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 75.301C0 75.301 10.3968 76.7001 21.005 73.5771C32.5429 70.1793 40.3025 59.5529 39.7108 47.7023C39.0093 33.6947 30.6833 21.0363 42.3565 2.07367C42.3565 2.07367 27.4121 14.2158 30.1424 43.0886C30.3621 45.3955 30.3368 47.7273 30.024 50.0258C26.9472 72.9442 0 75.301 0 75.301Z",
    fill: "#DF76F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3286 55.9552C24.4227 55.9552 27.7416 52.6853 27.7416 48.6517C27.7416 44.618 24.4227 41.3481 20.3286 41.3481C16.2345 41.3481 12.9155 44.618 12.9155 48.6517C12.9155 52.6853 16.2345 55.9552 20.3286 55.9552Z",
    fill: "#DF76F8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_127_176"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 95,
    height: 84.4866,
    fill: "white",
    transform: "translate(0 0.757874)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrend);
export default __webpack_public_path__ + "static/media/trend.0e2ab06160f04f979ac9e1fc8b3b62ba.svg";
export { ForwardRef as ReactComponent };